import { postRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getLinkToken = () =>
  postRequest(replaceInUrl(apiEndpoints.plaid.getToken));
